<template>
	<div class="row student-statistic">
		<div class="section col-12">
			<div class="row">
				<div class="col-xl-3 col-lg-4">
					<h5>
						<i class="fa fa-bookmark" aria-hidden="true" />
						{{ 'History statistics' | translate }}
					</h5>
					<div class="inner">
						<h5>{{ 'Choose date' | translate }}</h5>
						<datepicker
							v-model="date"
							@input="updateStatistic()"
							:format="format"
						></datepicker>
					</div>
				</div>
				<div class="col-xl-6 col-lg-4">
					<h5>
						<i class="fa fa-bar-chart" aria-hidden="true" />
						{{ 'Game statistics per day' | translate }}
					</h5>
					<div class="inner text-center ">
						<div class="row align-items-center">
							<div class="col">
								<h4>{{ statistic.today.total }}</h4>
								<h6>{{ 'Total played games' | translate }}</h6>
							</div>
							<div class="col">
								<h4>{{ statistic.today.right_answers }}</h4>
								<h6>{{ 'Total correct answers' | translate }}</h6>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xl-3 col-lg-4">
					<h5>
						<i class="fa fa-eye" aria-hidden="true" /> {{ 'Total' | translate }}
					</h5>
					<div class="inner text-center">
						<h6>{{ 'Total played:' | translate }}</h6>
						<h4>{{ statistic.all_time.total }} {{ 'Games' | translate }}</h4>
						<table class="table">
							<tbody>
								<tr>
									<td>{{ 'match.column' | translate }}</td>
									<td>{{ statistic.all_time.columns || 0 }}</td>
								</tr>
								<tr>
									<td>{{ 'Speedy numbers' | translate }}</td>
									<td>{{ statistic.all_time.addition || 0 }}</td>
								</tr>
								<tr>
									<td>{{ 'Anzan' | translate }}</td>
									<td>{{ statistic.all_time.anzan || 0 }}</td>
								</tr>
								<tr>
									<td>{{ 'Abacus is random' | translate }}</td>
									<td>{{ statistic.all_time.abacus_random || 0 }}</td>
								</tr>
								<tr>
									<td>{{ 'Multiplication' | translate }}</td>
									<td>{{ statistic.all_time.multiply || 0 }}</td>
								</tr>
								<tr>
									<td>{{ 'Division' | translate }}</td>
									<td>{{ statistic.all_time.divide || 0 }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import datepicker from 'vuejs-datepicker'

export default {
	name: 'statistic',
	data() {
		return {
			format: 'dd/MM/yyyy',
			date: new Date(),
			statistic: {
				today: {
					total: 0,
					right_answers: 0,
				},
				all_time: {
					total: 0,
				},
			},
		}
	},
	components: {
		datepicker,
	},
	methods: {
		updateStatistic() {
			let day = new Date(this.date).getDate()
			let month = new Date(this.date).getMonth() + 1
			let year = new Date(this.date).getFullYear()
			this.axios({
				method: 'get',
				url: `lessons/game/data/statistic?day=${day}&month=${month}&year=${year}&user=${this
					.$route.query.read_only || this.$store.state.myProfile.id}`,
			}).then(response => {
				this.statistic = response.data
			})
		},
	},
	created() {
		this.updateStatistic()
	},
}
</script>

<style>
.student-statistic input {
	width: 100%;
	padding-right: 10px;
	padding-left: 10px;
}
</style>

<style scoped>
.section {
	padding: 40px 30px;
}

.inner {
	background-color: #fff;
	border-radius: 5px;
	border: 1px solid #e2e7eb;
	padding: 20px;
	height: auto;
}

.inner .row {
	height: 100%;
}

.inner img {
	display: inline-block;
	margin-top: 30px;
	margin-bottom: 30px;
}

.inner .btn-warning {
	width: 100%;
	font-size: 20px;
	margin-top: 10px;
}

@media (max-width: 575px) {
	.header,
	.header .text-right {
		text-align: center !important;
	}
}

@media (min-width: 576px) and (max-width: 767px) {
}

@media (max-width: 991px) {
	h5 {
		margin-top: 30px;
	}
}

@media (min-width: 992px) and (max-width: 1199px) {
	h5 {
		font-size: 19px;
	}
}
</style>
